var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69244",
    "data-name": "Group 69244",
    transform: "translate(19710 11097)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17347",
    "data-name": "Rectangle 17347",
    width: 24,
    height: 24,
    transform: "translate(-19710 -11097)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-19708.5 -11093.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69243",
    "data-name": "Group 69243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69242",
    "data-name": "Group 69242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37384",
    "data-name": "Path 37384",
    d: "M2.286,16.016l-1.277-8.3a.693.693,0,0,1,1.1-.66l3.98,2.985a.951.951,0,0,0,1.362-.233l3.313-4.97a.885.885,0,0,1,1.472,0l3.313,4.97a.951.951,0,0,0,1.362.233l3.98-2.985a.693.693,0,0,1,1.1.66l-1.277,8.3Z",
    transform: "translate(-1 -4.441)",
    fill: "#ff9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37385",
    "data-name": "Path 37385",
    d: "M20.3,26.242H3.8a.961.961,0,0,1-.961-.961v-2.11H21.265v2.11A.961.961,0,0,1,20.3,26.242Z",
    transform: "translate(-1.551 -10.06)",
    fill: "#ff9500"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.95461a449e5967bc2419fb1d94bcbbbe.svg";
export { ForwardRef as ReactComponent };